export default {
  EmptyState: {
    title: 'Adicione o seu primeiro restaurante',
    description: 'Ainda não tem restaurantes. Crie um para começar a configurá-lo e receber encomendas.',
    cta: 'Novo Restaurante',
  },
};
